export declare namespace ActivitiesMultiselectTokenSections {
	interface Group {
		background: string;
		color: string;
		fontWeight: string;
		fontSize: string;
	}

	interface Item {
		background: string;
		color: string;
		fontWeight: string;
		fontSize: string;
	}

	interface ItemSelected {
		color: string;
		fontWeight: string;
		fontSize: string;
	}
}

export type ActivitiesMultiselectTokens = {
	group: ActivitiesMultiselectTokenSections.Group;
	item: ActivitiesMultiselectTokenSections.Item;
	itemSelected: ActivitiesMultiselectTokenSections.ItemSelected;
};

export const group: ActivitiesMultiselectTokenSections.Group = {
	background: '{overlay.select.background}',
	color: '{slate.700}',
	fontWeight: '400',
	fontSize: '0.875rem',
};

export const item: ActivitiesMultiselectTokenSections.Item = {
	background: '{overlay.select.background}',
	color: '{slate.700}',
	fontWeight: '400',
	fontSize: '0.875rem',
};

export const itemSelected: ActivitiesMultiselectTokenSections.ItemSelected = {
	color: '{slate.700}',
	fontWeight: '600',
	fontSize: '0.875rem',
};

export default {
	group,
	item,
	itemSelected,
} satisfies ActivitiesMultiselectTokens;
